import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';
import { MenuItem } from './types';
import ButtonCommon from '../buttons/ButtonCommon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DropDownMenu',
  props: {
    menuItems: null,
    dark: { type: Boolean },
    button: { type: Boolean },
    onImage: { type: Boolean },
    small: { type: Boolean },
    tooltip: null,
    iconSize: null,
    nudgeRight: null,
    attachId: null,
    customToggler: { type: Boolean },
    disabled: { type: Boolean },
    width: null,
    buttonType: { default: '' },
    buttonIconSize: { default: 20 },
    top: { type: Boolean, default: false },
    nudgeTop: { default: 0 },
    maxHeight: { default: 'auto' }
  },
  emits: ["menuCollapsed", "select"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'menuCollapsed', value: boolean): void;
  (e: 'select', value: string | number | boolean | object): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { menuItems: MenuItem[], dark?: boolean, button?: boolean, onImage?: boolean, small?: boolean, tooltip?: string, iconSize?: number, nudgeRight?: number, attachId?: string, customToggler?: boolean, disabled?: boolean, width?: number, buttonType: '' | 'clear', buttonIconSize: number, top: boolean, nudgeTop: number, maxHeight: number | 'auto' };





const show = ref(false);
const showTooltip = ref(false);

const getNudgeRightValue = computed(() => {
  if (props.small) {
    return '-195';
  } else if (props.onImage) {
    return '-168';
  } else if (props.button) {
    return '-175';
  } else {
    return props.nudgeRight ? -185 - props.nudgeRight : '-185';
  }
});

watch(
  () => show.value,
  () => {
    showTooltip.value = false;
    emit('menuCollapsed', show.value);
  }
);

function itemClick(item: MenuItem) {
  show.value = false;
  if (!item.disabled && item.value) {
    emit('select', item.value);
  }
}

return { __sfc: true,props, emit, show, showTooltip, getNudgeRightValue, itemClick, ButtonCommon }
}

})